class Collapsible {
	constructor(element) {
		this.element = element;
		this._drawer = element.querySelector('.collapsible__drawer');
		this._button = element.querySelector('.collapsible__button');

		this._handleButtonClick = this._handleButtonClick.bind(this);
		this._listen();

		this.element.classList.add('collapsible--initialized');
	}

	_listen() {
		this._button.addEventListener('click', this._handleButtonClick);
	}

	_handleButtonClick() {
		if (this._collapsed) this.expand();
		else this.collapse();
	}

	collapse() {
		this._drawer.style.height = `0px`;
		this._collapsed = true;
		this.element.classList.add('collapsible--collapsed');
	}

	expand() {
		this._drawer.style.height = `${this._drawer.scrollHeight}px`;
		this._collapsed = false;
		this.element.classList.remove('collapsible--collapsed');
	}

	destroy() {
		this.expand();
		this._button.removeEventListener('click', this._handleButtonClick);
		this.element.classList.remove('collapsible--initialized');
	}
}

const initCollapsible = (collapsibleEl) => {
	const collapsible = new Collapsible(collapsibleEl);
	collapsibleEl._collapsible = collapsible;
	collapsible.collapse();
};

const destroyCollapsible = (collapsibleEl) => {
	collapsibleEl._collapsible?.destroy();
	collapsibleEl._collapsible = null;
};

const updateCollapsibles = (isInit) => {
	document.querySelectorAll('.collapsible').forEach((collapsibleEl) => {
		if (isInit) initCollapsible(collapsibleEl);
		else destroyCollapsible(collapsibleEl);
	});
};

updateCollapsibles(true);
